// Brand colours a step lighter or darker where they carry text, so the text reads at WCAG AA
// (4.5:1). Each is the smallest step from its brand colour that passes:
// - green text on the app's dark blue panels, whose lightest shade is #1d2f44 (#469f6a: 4.17:1)
export const GREEN_TEXT_ON_DARK = '#49A66F';
// - orange text on the same panels (#ca7c62: 4.26:1)
export const ORANGE_TEXT_ON_DARK = '#CD826A';
// - the green behind a white badge label in a menu item drawn at 80% opacity (#28856f: 3.8:1)
export const BADGE_GREEN = '#237562';
